import icon from "../../assets/nextAi.svg";
import type { Property } from "../../types";

export const aiRecognition: Property = {
  id: "aiRecognition",
  title: "aiRecognition.title",
  icon,
};
